import React from "react";
import Circle from "../../assets/images/Circle.svg";

const AlertTimelineItem = props => (
  <div className="cb-c-alert-timeline-item__status-change">
    <div className="cb-c-alert-timeline-item__status-change__icon">
      <div className="cb-c-alert-timeline-item__status-change__icon__top">
        <svg height={35} width={15}>
          <line
            x1="2"
            y1="35"
            x2="2"
            y2="0"
            className="cb-c-alert-timeline-item__status-change__icon__top__line"
          />
        </svg>
      </div>
      <img src={Circle} alt="Circle" height={20} width={20} />
      <div className="cb-c-alert-timeline-item__status-change__icon__bottom">
        <svg height="100%" width={15}>
          <line
            x1="2"
            y1="100%"
            x2="2"
            y2="0"
            className="cb-c-alert-timeline-item__status-change__icon__bottom__line"
          />
        </svg>
      </div>
    </div>
    <div className="fable:pl-4 cb-c-alert-timeline-item__status-change__message">
      {props.children}
    </div>
  </div>
);

export default AlertTimelineItem;
